import { API_BASE } from "config/api";
import { withAuthHeaders } from "services/authHeader";
import { apiFetch } from "services/apiFetch";

export async function getRegions() {
  try {
    const url = new URL("api/sdb/getRegions", API_BASE);
    const result = await apiFetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    }).then((r) => r.json());
    if (result.status === "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in getRegions:", error);
    throw error;
  }
  return [];
}

export async function getIAs(regionId) {
  try {
    const url = new URL("api/sdb/getIAs", API_BASE);
    url.searchParams.set("regionId", regionId || "");
    const result = await apiFetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    }).then((r) => r.json());
    if (result.status === "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in getIAs:", error);
    throw error;
  }
  return [];
}

export async function getIEFs(iaId, departmentId) {
  try {
    const url = new URL("api/sdb/getIEFs", API_BASE);
    if (iaId) url.searchParams.set("iaId", iaId);
    if (departmentId) url.searchParams.set("departmentId", departmentId);
    const result = await apiFetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    }).then((r) => r.json());
    if (result.status === "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in getIEFs:", error);
    throw error;
  }
  return [];
}

export async function getDepartments(regionId) {
  try {
    const url = new URL("api/sdb/getDepartments", API_BASE);
    if (regionId) {
      url.searchParams.set("regionId", regionId);
    }
    const result = await apiFetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    }).then((r) => r.json());
    if (result.status === "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in getDepartments:", error);
    throw error;
  }
  return [];
}

export async function resolveHierarchy(departmentName, iefName) {
  try {
    const url = new URL("api/sdb/resolveHierarchy", API_BASE);
    url.searchParams.set("departmentName", departmentName || "");
    if (iefName) url.searchParams.set("iefName", iefName);
    const result = await apiFetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    }).then((r) => r.json());
    if (result.status === "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in resolveHierarchy:", error);
    throw error;
  }
  return null;
}

/* program api call */
export async function getPrograms() {
  try {
    let url = new URL("api/programs/getPrograms", API_BASE);
    let result = await apiFetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });
    result = await result.json();
    if (result.status == "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in getPrograms:", error);
    throw error; // Rethrow to be caught in fetchDropdownData
  }
}
